/**
 * 施策のKPI
 */
const measureKpi = {
  1: { name: 'ページビュー', seller: true, maker: true, sourcing: false },
  2: { name: '注文率', seller: true, maker: true, sourcing: false },
  3: { name: '平均売価', seller: true, maker: true, sourcing: true },
  4: { name: '自然売上', seller: true, maker: true, sourcing: true },
  5: { name: '広告経由売上', seller: true, maker: true, sourcing: true },
  6: { name: 'ROAS', seller: true, maker: true, sourcing: true },
  7: { name: 'CPC', seller: true, maker: true, sourcing: true },
  8: { name: 'CVR', seller: true, maker: true, sourcing: true },
  9: { name: 'CV単価', seller: true, maker: true, sourcing: true },
  10: { name: 'カート獲得率', seller: true, maker: false, sourcing: false }
}

export default measureKpi
